import type { PageComponentMetaWithPosition } from '@/core/features/a-dynamic-page/dynamic-page-pacts/dynamic-page-type';
import type { PageComponentProps } from '@/features/a-dynamic-page/components/page-component-switch';
import type { HighlightHeaderV1Attributes } from '@/features/highlight-header/highlight-header-v1-type';

import DividerHorizontalDesktop from '@/core/components/divider/divider-horizontal-desktop';
import { Badges } from '@/core/features';
import useSticky from '@/core/features/scroll/use-sticky';
import HeaderMapButtonDesktop from '@/features/map/header-map-button-desktop/header-map-button-desktop';

export type HighlightHeaderV1DesktopProps = PageComponentProps<
    HighlightHeaderV1Attributes,
    PageComponentMetaWithPosition
>;

export default function HighlightHeaderV1Desktop({ attributes, meta }: HighlightHeaderV1DesktopProps) {
    const { ref: stickyRef, stickyStyle } = useSticky(meta.position === 'sticky' ? 'HighlightHeaderV1Desktop' : null);
    const { badges, highlightType, mapButton, title } = attributes;

    return (
        <div
            className={'width-100 -margin-top-10'}
            data-scroll-padding={meta.position === 'sticky'}
            ref={stickyRef}
            style={{ ...stickyStyle }}
        >
            <div
                className={
                    'flex-space-between-horizontal bg-white nowrap gap-30 align-center padding-top-15 padding-right-0 padding-left-0 padding-bottom-20'
                }
            >
                <div className={'font-size-22'}>
                    <h1 className={'width-100 break-anywhere bold'}>{title}</h1>
                    <div className={'flex-start gap-20 align-center'}>
                        <div>
                            <h2 className={'break-anywhere'}>{highlightType}</h2>
                        </div>
                        <div>
                            <Badges
                                badges={badges}
                                fontSize={14}
                                marginBottom={-2}
                                type={'horizontal'}
                            />
                        </div>
                    </div>
                </div>
                {mapButton && (
                    <HeaderMapButtonDesktop
                        iconUrl={mapButton.iconUrl}
                        linkUrl={mapButton.linkUrl}
                        title={mapButton.text}
                        width={'120px'}
                    />
                )}
            </div>
            <DividerHorizontalDesktop
                color={'alto'}
                marginBottom={0}
                marginTop={0}
            />
        </div>
    );
}
